import * as React from "react";
import styled from "styled-components";

import { themeValues } from "../theme";

export const StyledBadge = styled.div`
  border: 1px solid ${themeValues.primaryColor};
  border-radius: 50px;
  display: inline-flex;
  align-items: center;
  padding: 0 8px;
  height: 18px;
  margin: 3px 4px;
  cursor: initial;

  .primary {
    border-color: ${themeValues.primaryColor};
  }
  
  .badge-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
StyledBadge.displayName = "StyledBadge";

type BadgeColors = "primary"

interface IBadgeProps {
  color?: BadgeColors;
  children: React.ReactNode | string;
}

export function Badge({
                        color = "primary",
                        children
                      }: IBadgeProps): JSX.Element {

  return <StyledBadge className={color}>
    <span className="badge-text">
      {children}
    </span>
  </StyledBadge>;

}